/**
 * Notification SignalR Constants
 * 
 * Defines the hub name and method names for the FrontDoor notification hub.
 * Uses the same method names as the leadhub notification methods for compatibility.
 */

const _Hub_Name = "frontdoor-notifications";

const _Invoke_Methods_Names = {
  markAsRead: "MarkNotificationAsRead",
  markAllAsRead: "MarkAllNotificationsAsRead",
};

const _OnReceive_Methods_Names = {
  onNotificationArrived: "NotificationSavedResponse",
  onNotificationUpdated: "UpdateNotificationResponse",
};

const Notification_signalr = {
  hubName: _Hub_Name,
  InvokeMethodNames: _Invoke_Methods_Names,
  onReceiveMethodNames: _OnReceive_Methods_Names,
};

export default Notification_signalr;
